import { useEffect, useState } from "react";
import { Space, Table } from "antd";
import { PageHeader } from "../../components/PageHeader";
import { TableDownload } from "../../components/TableDownload";
import { ColumnPicker, useColumnPicker } from "../../components/ColumnPicker";
import { api } from "../../helpers/api";
import type { ExportColumns } from "../../helpers/csv";
import type { LowStockRow } from "../../api-models";

// One definition behind both the table and its export.
const COLUMNS: ExportColumns<LowStockRow> = [
  { title: "Code", dataIndex: "itemCode" },
  { title: "Item", dataIndex: "itemName" },
  { title: "On hand", dataIndex: "onHand" },
  { title: "Reorder level", dataIndex: "reorderLevel" },
];

export default function LowStockReportPage() {
  const [rows, setRows] = useState<LowStockRow[]>([]);
  const cols = useColumnPicker("report:low-stock", COLUMNS);

  useEffect(() => {
    api.get<LowStockRow[]>("/reports/low-stock").then((res) => setRows(res.data));
  }, []);

  return (
    <div>
      <PageHeader
        title="Low Stock"
        extra={
          <Space>
            <ColumnPicker state={cols} />
            <TableDownload name="Low Stock" columns={cols.visible} dataSource={rows} disabled={!rows.length} />
          </Space>
        }
      />
      <Table rowKey="itemId" dataSource={rows} columns={cols.visible} />
    </div>
  );
}
